export default function () {
  const widgetName = 'headerButtonsCSFFoundation';
  const widgetOpts = headerButtonsCSFFoundationOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      let btnShape = `
      <svg class="btn-shape" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 160 55" xml:space="preserve">
      <g>
        <path class="st0" d="M9.03,54.41c-1,0-2,0-3,0c-1.21-1.32-4.18,0.75-4.48-2.32c-0.19-6.87,0.87-13.77-0.51-20.6   c0-1.66,0-3.32,0-4.98c1.02-2.77,0.27-5.64,0.5-8.45c0.6-5.81-1.42-11.85,1.5-17.46c51.3,0,102.59,0,153.89,0   c1.93,1.96,0.95,4.76,2,6.98c0,2.99,0,5.98,0,8.97c-0.79,3.65-0.79,7.31,0,10.96c0,1,0,1.99,0,2.99c-1.06,2.22-0.25,4.57-0.5,6.84   c0.14,3.08-0.22,6.17-0.01,9.25c0.17,2.93-0.23,5.67-2.49,7.83c-1.67,0-3.45-0.54-5.12-0.54c-9.42-1.37-18.8-0.82-28.28-1.3   c-1.98-0.1-3.95-0.19-5.93-0.27c-0.65-0.03-1.31,0.36-1.96,0.34c-0.66-0.02-1.3-0.46-1.96-0.48c-10.45-0.36-20.9-0.46-31.35-0.42   c-1.69,0.01-3.34,0.39-5.03,0.4c-1.26,0.01-2.56-0.36-3.82-0.34c-4.75,0.04-9.5,0.11-14.25,0.18c-8.89,0.14-17.79,0.29-26.68,0.7   c-1.07,0.05-1.91,0.64-2.98,0.69C22.11,53.71,15.45,53.67,9.03,54.41z"/>
      </g>
      </svg>`

      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.buttonwrap').remove();
        $(this).removeAttr('target');
        $(this).append(btnShape);

        // Accessibility attrs
        $(this).attr('title',data.items[x].Title);
        $(this).attr('aria-label',data.items[x].Title);
        $(this).attr('role','link');
        $(this).attr('tabindex',x+1);
      })

      if (data.items.length > 0 && data.items[1].Title == "Get Tickets") {
        $('.mobile-menu-slider').after(`
        <div id="ticket-container-mobile">
        
        <div class="btn-container">
        <a href="${data.items[1].URL}" class="ticket-mobile">Get Tickets</a>
        ${btnShape}</div>
        </div>
        `)

      } else {
        $('#ticket-container-mobile').remove();
      }

      if (widgetName.length > 0) {
        $(`#${widgetName}`).css('opacity', '1');
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}